export default "__VITE_ASSET__CRLtdFL0__"